import { Component } from "react";
import { Container } from "react-bootstrap";
import { MDBBtn, MDBModal, MDBModalBody, MDBModalHeader } from "mdb-react-ui-kit";
import { Tabs, TabList, Tab, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import axios, { AxiosError } from "axios";
import { toast } from "react-toastify";
import VehicleSimulator from "./vehicleSimulator";
import VehicleFormView from "./vehicleFormViewz";
import VehileJsonEdit from "./vehileJsonEdit";
import Select from "react-select";
import VehicleFunction from "./vehicleFunction";
import messageService from "../messageService/messageService";
//import SessionExpired from "../sessionExpire/SessionExpired";
import * as config from "../../config";
import KafkaSimulator from "./kafkaSimulator";

interface DTProps {
  jwtToken: string | null;
}

class DeviceTwin extends Component<DTProps, any> {
  stepper: any;
  statusSubscription: any;
  constructor(props: any) {
    super(props);
    const savedIndex = sessionStorage.getItem("selectedTabIndex");
    this.state = {
      jwtToken: "",
      resultcodedb: "",
      dropdownKey: 0,
      selectedIndex: savedIndex ? parseInt(savedIndex, 10) : 0,
      //sessionExpired: false,
      carPointer: false,
      innerselectedIndex: 0,
      deviceID: "",
      selectedOption: [{ value: "gallon", label: "Gallon" }],
      destinationselectedOption: [{ value: "dynamoDB", label: "DynamoDB" }],
      mqttbrokertopicboolean: false,
      selectfinaldata: "Gallon",
      destinationselectedData: "DynamoDB",
      mqttopicselectedData: "topic1",
      weeks: [
        { value: 1, label: "1:Mon" },
        { value: 2, label: "2:Tue" },
        { value: 3, label: "3:Wed" },
        { value: 4, label: "4:Thu" },
        { value: 5, label: "5:Fri" },
        { value: 6, label: "6:Sat" },
        { value: 7, label: "7:Sun" },
      ],
      isOpen: false,
      vehicalStateData: {
        door_FDL: false,
        door_FDR: false,
        door_RDL: false,
        door_RDR: false,
        keydetected: false,
        klegconfirmation: false,
        oC_door_FDL: false,
        oC_door_FDR: false,
        oC_door_RDL: false,
        oC_door_RDR: false,
        engine_sts: false,
        svt: false,
        cabin_outSts: false,
        seat_RStRem: false,
        health_fuel_Sts: 20,
        health_fuel_Lvl_chrg: 50,
        health_fuel_Lvl_gas: 30,
        health_fuel_Lvl_h2: 45,
        health_DTE_tot: 12,
        health_DTE_ev: 30,
        health_DTE_gas: 47,
        health_DTE_h2: 65,
        health_DTE_GTDU: "",
        health_DTE_evTDstSR: "",
        health_DTE_PS_GPSPT: "",
        health_DTE_PS_slr: "",
        health_DTE_PS_BPSPT: "",
        health_odo_lfTm: "",
        health_odo_tripA: "",
        health_odo_tripB: "",
        health_fuelEco_lstTrip: "",
        health_fuelEco_lfTm: "",
        health_TP_RLTP: "",
        health_TP_RRTP: "",
        health_TP_STP: "",
        health_TP_FLTP: "",
        health_TP_FRTP: "",
        health_battery_sts: 80,
        health_battery_Keyfob: "",
        health_oil_lfTm: "",
        extendedOpenings_trunk: false,
        extendedOpenings_roof: false,
        extendedOpenings_trunks: false,
        extendedOpenings_trunkl: false,
        extendedOpenings_hatch: false,
        extendedOpenings_hatchs: false,
        extendedOpenings_tailgate: false,
        extendedOpenings_tailgates: false,
        extendedOpenings_hood: false,

        extendedOpenings_roofs: false,
        windows_FWR: false,
        windows_FWL: false,
        windows_RWL: false,
        windows_RWR: false,
        windows_backdoor: false,

        // "windows_snRf": false,
        alerts_Horn: false,
        alerts_Buzzer: false,
        alerts_Hazards: false,
        lamps_FL: false,
        lamps_RL: false,
        lamps_Hazards: false,
        seat_R2R: "returnwalkin",
        seat_R2L: "returnwalkin",
        seat_R3R: "",
        seat_R3C: "",
        seat_R3L: "",
        plug_plgHsty: 12,
        plug_plgSts: 12,
        charge_prof_pId: "V1d25",
        charge_prof_chrgTyp: 1,
        charge_prof_SoT: "16:50",
        charge_prof_SrT: "12:50",
        charge_prof_active: true,
        charge_sdl_chrgET: "14:50",
        charge_sdl_chrgST: "12:50",
        charge_sdl_setTyp: 0,
        charge_sdl_chrgWk: [0],
        charge_sdl_setID: 1,
        charge_sdl_active: true,
        charge_chrglmt: "10",
        charge_chrgPwrSW: "AC",
        charge_status_chrgPDF: 1,
        charge_status_chrgRemAmt: 30,
        charge_status_cntSts: 2,
        charge_status_remChgTm: 54,
        charge_status_setChAcc: 1,
        charge_status_cntLkSts: "lock",
        charge_status_prtLidSts: "lock",
        charge_status_swtSts: 0,
        tcll: false,
        charge_state_prtLidSts: "open",
        solar_solrPG: 5423,
        MechanicalAC: false,
        ExtendedOperation: false,
        UnlockImmobilizer: false,
        selectedResultCodeOption: null,
      },

      vehicleUploadData: {
        door: {
          FDL: true,
          FDR: false,
          RDL: false,
          RDR: true,
          oCFDL: true,
          oCFDR: false,
          oCRDL: false,
          oCRDR: true,
        },
        engine: {
          sts: true,
        },
        precondition: {
          keydetected: true,
          klegconfirmation: true,
        },
        targetchargelid: {
          tcll: true,
        },
        svtrequest: {
          svt: true,
        },
        cabin: {
          outSts: true,
        },
        seatRemainder: {
          RS: false,
        },
        health: {
          fuel: {
            Sts: "",
            Lvl: {
              chrg: "",
              gas: "",
              h2: "",
            },
          },
          DTE: {
            tot: "",
            ev: "",
            gas: "",
            h2: "",
            GTDU: "",
            evTDstSR: "",
            PS: {
              GPSPT: "",
              slr: "",
              BPSPT: "",
            },
          },
          odo: {
            lfTm: "",
            tripA: "",
            tripB: "",
          },
          fuelEco: {
            lstTrip: "",
            lfTm: "",
          },
          TP: {
            RLTP: "",
            RRTP: "",
            STP: "",
            FLTP: "",
            FRTP: "",
          },
          battery: {
            sts: "",
            Keyfob: "",
          },
          oil: {
            lfTm: "",
          },
        },
        extendedOpenings: {
          roof: {
            slRfPos: true,
            STR: true,
          },
          trunk: {
            lgC: true,
            BD: true,
            trunkl: true,
          },
          hatch: {
            hatchl: true,
            hatcho: true,
          },
          tailgate: {
            tailgatel: true,
            tailgateo: true,
          },
          hood: {
            hooddcs: true,
          },
        },
        windows: {
          FWR: false,
          FWL: false,
          RWL: false,
          RWR: false,
          backdoor: false,
        },
        alerts: {
          Horn: false,
          Buzzer: false,
          Hazards: false,
        },
        lamps: {
          FL: false,
          RL: false,
          Hazards: false,
        },
        seat: {
          R2R: "returnwalkin",
          R2L: "returnwalkin",
          R3R: "returnfold",
          R3C: "returnfold",
          R3L: "returnfold",
        },
        plug: {
          plgHsty: 12,
          plgSts: 12,
        },
        charge: {
          prof: {
            pId: "V1d25",
            chrgTyp: 1,
            SoT: "16:50",
            SrT: "12:50",
            active: true,
          },
          sdl: {
            chrgET: "14:50",
            chrgST: "12:50",
            setTyp: 0,
            chrgWk: "101010",
            setID: 1,
            active: true,
          },
          chrglmt: "10",
          chrgPwrSW: "AC",
          status: {
            chrgPDF: 1,
            chrgRemAmt: 30,
            cntSts: 2,
            remChgTm: 54,
            setChAcc: 1,
            cntLkSts: "lock",
            prtLidSts: "lock",
            swtSts: 0,
          },
          state: {
            prtLidSts: "open",
          },
        },
        solar: {
          solrPG: 5423,
        },
        climateControl: {
          MechanicalAC: false,
          ExtendedOperation: false,
          UnlockImmobilizer: false,
        },
        selectedResultCodeOption: "10",
      },
      updatedsampleJson: [],
      ruleData: [],
      ruleAllData: [],
    };

    // this.statusSubscription = messageService
    //   .getStatus()
    //   .subscribe((status: any) => {
    //     console.log("check Status code", status);
    //     if (status.message === "403") {
    //       this.setState({ sessionExpired: true });
    //     }
    //   });

    const queryParams1 = new URLSearchParams(window.location.search);
    const deviceid1 = queryParams1.get("deviceid");

    axios
      .get(config.rootUrl + `/v1/configuration/vehiclestatus/${deviceid1}`, {
        headers: {
          "x-api-key": config.apiKey,
          Authorization: "Bearer " + this.props.jwtToken,
        },
      })
      .then((res) => {
        const getdata = res.data;
        this.setState({
          resultcodedb: getdata?.Items[0].selectedResultCodeOption,
        });
        this.setState({
          vehicalStateData: {
            keydetected:
              getdata?.Items[0].precondition?.keydetected ??
              this.state.vehicalStateData.keydetected,
            klegconfirmation:
              getdata?.Items[0].precondition?.klegconfirmation ??
              this.state.vehicalStateData.klegconfirmation,
            door_FDL:
              getdata?.Items[0].door?.FDL ??
              this.state.vehicalStateData.door_FDL,
            door_FDR:
              getdata?.Items[0].door?.FDR ??
              this.state.vehicalStateData.door_FDR,
            door_RDL:
              getdata?.Items[0].door?.RDL ??
              this.state.vehicalStateData.door_RDL,
            door_RDR:
              getdata?.Items[0].door?.RDR ??
              this.state.vehicalStateData.door_RDR,
            oC_door_FDL:
              getdata?.Items[0].door?.oCFDL ??
              this.state.vehicalStateData.oC_door_FDL,
            oC_door_FDR:
              getdata?.Items[0].door?.oCFDR ??
              this.state.vehicalStateData.oC_door_FDR,
            oC_door_RDL:
              getdata?.Items[0].door?.oCRDL ??
              this.state.vehicalStateData.oC_door_RDL,
            oC_door_RDR:
              getdata?.Items[0].door?.oCRDR ??
              this.state.vehicalStateData.oC_door_RDR,
            engine_sts:
              getdata?.Items[0].engine?.sts ??
              this.state.vehicalStateData.engine_sts,
            svt:
              getdata?.Items[0].svtrequest?.svt ??
              this.state.vehicalStateData.svt,

            cabin_outSts:
              getdata?.Items[0].cabin?.outSts ??
              this.state.vehicalStateData.cabin_outSts,
            seat_RStRem:
              getdata?.Items[0].seatRemainder?.RS ??
              this.state.vehicalStateData.seat_RStRem,
            health_fuel_Sts:
              getdata?.Items[0].health?.fuel?.Sts ??
              this.state.vehicalStateData.health_fuel_Sts,
            health_fuel_Lvl_chrg:
              getdata?.Items[0].health?.fuel?.Lvl?.chrg ??
              this.state.vehicalStateData.health_fuel_Lvl_chrg,
            health_fuel_Lvl_gas:
              getdata?.Items[0].health?.fuel?.Lvl?.gas ??
              this.state.vehicalStateData.health_fuel_Lvl_gas,
            health_fuel_Lvl_h2:
              getdata?.Items[0].health?.fuel?.Lvl?.h2 ??
              this.state.vehicalStateData.health_fuel_Lvl_h2,
            health_DTE_tot:
              getdata?.Items[0].health?.DTE?.tot ??
              this.state.vehicalStateData.health_DTE_tot,
            health_DTE_ev:
              getdata?.Items[0].health?.DTE?.ev ??
              this.state.vehicalStateData.health_DTE_ev,
            health_DTE_gas:
              getdata?.Items[0].health?.DTE?.gas ??
              this.state.vehicalStateData.health_DTE_gas,
            health_DTE_h2:
              getdata?.Items[0].health?.DTE?.h2 ??
              this.state.vehicalStateData.health_DTE_h2,
            health_DTE_GTDU:
              getdata?.Items[0].health?.DTE?.GTDU ??
              this.state.vehicalStateData.health_DTE_GTDU,
            health_DTE_evTDstSR:
              getdata?.Items[0].health?.DTE?.evTDstSR ??
              this.state.vehicalStateData.health_DTE_evTDstSR,
            health_DTE_PS_GPSPT:
              getdata?.Items[0].health?.DTE?.PS?.GPSPT ??
              this.state.vehicalStateData.health_DTE_PS_GPSPT,
            health_DTE_PS_slr:
              getdata?.Items[0].health?.DTE?.PS?.slr ??
              this.state.vehicalStateData.health_DTE_PS_slr,
            health_DTE_PS_BPSPT:
              getdata?.Items[0].health?.DTE?.PS?.BPSPT ??
              this.state.vehicalStateData.health_DTE_PS_BPSPT,
            health_odo_lfTm:
              getdata?.Items[0].health?.odo?.lfTm ??
              this.state.vehicalStateData.health_odo_lfTm,
            health_odo_tripA:
              getdata?.Items[0].health?.odo?.tripA ??
              this.state.vehicalStateData.health_odo_tripA,
            health_odo_tripB:
              getdata?.Items[0].health?.odo?.tripB ??
              this.state.vehicalStateData.health_odo_tripB,
            health_fuelEco_lstTrip:
              getdata?.Items[0].health?.fuelEco?.lstTrip ??
              this.state.vehicalStateData.health_fuelEco_lstTrip,
            health_fuelEco_lfTm:
              getdata?.Items[0].health?.fuelEco?.lfTm ??
              this.state.vehicalStateData.health_fuelEco_lfTm,
            health_TP_RLTP:
              getdata?.Items[0].health?.TP?.RLTP ??
              this.state.vehicalStateData.health_TP_RLTP,
            health_TP_RRTP:
              getdata?.Items[0].health?.TP?.RRTP ??
              this.state.vehicalStateData.health_TP_RRTP,
            health_TP_STP:
              getdata?.Items[0].health?.TP?.STP ??
              this.state.vehicalStateData.health_TP_STP,
            health_TP_FLTP:
              getdata?.Items[0].health?.TP?.FLTP ??
              this.state.vehicalStateData.health_TP_FLTP,
            health_TP_FRTP:
              getdata?.Items[0].health?.TP?.FRTP ??
              this.state.vehicalStateData.health_TP_FRTP,
            health_battery_sts:
              getdata?.Items[0].health?.battery?.sts ??
              this.state.vehicalStateData.health_battery_sts,
            health_battery_Keyfob:
              getdata?.Items[0].health?.battery?.Keyfob ??
              this.state.vehicalStateData.health_battery_Keyfob,
            health_oil_lfTm:
              getdata?.Items[0].health?.oil?.lfTm ??
              this.state.vehicalStateData.health_oil_lfTm,
            extendedOpenings_trunk:
              getdata?.Items[0].extendedOpenings?.trunk?.lgC ??
              this.state.vehicalStateData.extendedOpenings_trunk,
            extendedOpenings_trunks:
              getdata?.Items[0].extendedOpenings?.trunk?.BD ??
              this.state.vehicalStateData.extendedOpenings_trunks,
            extendedOpenings_trunkl:
              getdata?.Items[0].extendedOpenings?.trunk?.trunkl ??
              this.state.vehicalStateData.extendedOpenings_trunkl,

            extendedOpenings_hatch:
              getdata?.Items[0].extendedOpenings?.hatch?.hatchl ??
              this.state.vehicalStateData.extendedOpenings_hatch,
            extendedOpenings_hatchs:
              getdata?.Items[0].extendedOpenings?.hatch?.hatcho ??
              this.state.vehicalStateData.extendedOpenings_hatchs,
            extendedOpenings_tailgate:
              getdata?.Items[0].extendedOpenings?.tailgate?.tailgatel ??
              this.state.vehicalStateData.extendedOpenings_tailgate,
            extendedOpenings_tailgates:
              getdata?.Items[0].extendedOpenings?.tailgate?.tailgateo ??
              this.state.vehicalStateData.extendedOpenings_tailgates,

            extendedOpenings_hood:
              getdata?.Items[0].extendedOpenings?.hood?.hooddcs ??
              this.state.vehicalStateData.extendedOpenings_hood,

            extendedOpenings_roof:
              getdata?.Items[0].extendedOpenings?.roof?.slRfPos ??
              this.state.vehicalStateData.extendedOpenings_roof,
            extendedOpenings_roofs:
              getdata?.Items[0].extendedOpenings?.roof?.STR ??
              this.state.vehicalStateData.extendedOpenings_roofs,

            windows_FWR:
              getdata?.Items[0].windows?.FWR ??
              this.state.vehicalStateData.windows_FWR,
            windows_FWL:
              getdata?.Items[0].windows?.FWL ??
              this.state.vehicalStateData.windows_FWL,
            windows_RWL:
              getdata?.Items[0].windows?.RWL ??
              this.state.vehicalStateData.windows_RWL,
            windows_RWR:
              getdata?.Items[0].windows?.RWR ??
              this.state.vehicalStateData.windows_RWR,
            windows_backdoor:
              getdata?.Items[0].windows?.backdoor ??
              this.state.vehicalStateData.windows_backdoor,

            // "windows_snRf": getdata?.Items[0].windows.snRf,

            alerts_Horn:
              getdata?.Items[0].alerts?.Horn ??
              this.state.vehicalStateData.alerts_Horn,
            alerts_Buzzer:
              getdata?.Items[0].alerts?.Buzzer ??
              this.state.vehicalStateData.alerts_Buzzer,
            alerts_Hazards:
              getdata?.Items[0].alerts?.Hazards ??
              this.state.vehicalStateData.alerts_Hazards,
            lamps_FL:
              getdata?.Items[0].lamps?.FL ??
              this.state.vehicalStateData.lamps_FL,
            lamps_RL:
              getdata?.Items[0].lamps?.RL ??
              this.state.vehicalStateData.lamps_RL,
            lamps_Hazards:
              getdata?.Items[0].lamps?.Hazards ??
              this.state.vehicalStateData.lamps_Hazards,
            seat_R2R:
              getdata?.Items[0].seat?.R2R ??
              this.state.vehicalStateData.seat_R2R,
            seat_R2L:
              getdata?.Items[0].seat?.R2L ??
              this.state.vehicalStateData.seat_R2L,
            seat_R3R:
              getdata?.Items[0].seat?.R3R ??
              this.state.vehicalStateData.seat_R3R,
            seat_R3C:
              getdata?.Items[0].seat?.R3C ??
              this.state.vehicalStateData.seat_R3C,
            seat_R3L:
              getdata?.Items[0].seat?.R3L ??
              this.state.vehicalStateData.seat_R3L,

            plug_plgHsty:
              getdata?.Items[0].plug?.plgHsty ??
              this.state.vehicalStateData.plug_plgHsty,
            plug_plgSts:
              getdata?.Items[0].plug?.plgSts ??
              this.state.vehicalStateData.plug_plgSts,
            charge_prof_pId:
              getdata?.Items[0].charge?.prof?.pId ??
              this.state.vehicalStateData.charge_prof_pId,
            charge_prof_chrgTyp:
              getdata?.Items[0].charge?.prof?.chrgTyp ??
              this.state.vehicalStateData.charge_prof_chrgTyp,
            charge_prof_SoT:
              getdata?.Items[0].charge?.prof?.SoT ??
              this.state.vehicalStateData.charge_prof_SoT,
            charge_prof_SrT:
              getdata?.Items[0].charge?.prof?.SrT ??
              this.state.vehicalStateData.charge_prof_SrT,
            charge_prof_active:
              getdata?.Items[0].charge?.prof?.active ??
              this.state.vehicalStateData.charge_prof_active,
            charge_sdl_chrgET:
              getdata?.Items[0].charge?.sdl?.chrgET ??
              this.state.vehicalStateData.charge_sdl_chrgET,
            charge_sdl_chrgST:
              getdata?.Items[0].charge?.sdl?.chrgST ??
              this.state.vehicalStateData.charge_sdl_chrgST,
            charge_sdl_setTyp:
              getdata?.Items[0].charge?.sdl?.setTyp ??
              this.state.vehicalStateData.charge_sdl_setTyp,
            charge_sdl_chrgWk:
              getdata?.Items[0].charge?.sdl?.chrgWk ??
              this.state.vehicalStateData.charge_sdl_chrgWk,
            charge_sdl_setID:
              getdata?.Items[0].charge?.sdl?.setID ??
              this.state.vehicalStateData.charge_sdl_setID,
            charge_sdl_active:
              getdata?.Items[0].charge?.sdl?.active ??
              this.state.vehicalStateData.charge_sdl_active,
            charge_chrglmt:
              getdata?.Items[0].charge?.chrglmt ??
              this.state.vehicalStateData.charge_chrglmt,
            charge_chrgPwrSW:
              getdata?.Items[0].charge?.chrgPwrSW ??
              this.state.vehicalStateData.charge_chrgPwrSW,
            charge_status_chrgPDF:
              getdata?.Items[0].charge?.status?.chrgPDF ??
              this.state.vehicalStateData.charge_status_chrgPDF,
            charge_status_chrgRemAmt:
              getdata?.Items[0].charge?.status?.chrgRemAmt ??
              this.state.vehicalStateData.charge_status_chrgRemAmt,
            charge_status_cntSts:
              getdata?.Items[0].charge?.status?.cntSts ??
              this.state.vehicalStateData.charge_status_cntSts,
            charge_status_remChgTm:
              getdata?.Items[0].charge?.status?.remChgTm ??
              this.state.vehicalStateData.charge_status_remChgTm,
            charge_status_setChAcc:
              getdata?.Items[0].charge?.status?.setChAcc ??
              this.state.vehicalStateData.charge_status_setChAcc,
            charge_status_cntLkSts:
              getdata?.Items[0].charge?.status?.cntLkSts ??
              this.state.vehicalStateData.charge_status_cntLkSts,
            charge_status_prtLidSts:
              getdata?.Items[0].charge?.status?.prtLidSts ??
              this.state.vehicalStateData.charge_status_prtLidSts,
            charge_status_swtSts:
              getdata?.Items[0].charge?.status?.swtSts ??
              this.state.vehicalStateData.charge_status_swtSts,
            charge_state_prtLidSts:
              getdata?.Items[0].charge?.state?.prtLidSts ??
              this.state.vehicalStateData.charge_state_prtLidSts,

            tcll:
              getdata?.Items[0].targetchargelid?.tcll ??
              this.state.vehicalStateData.tcll,

            solar_solrPG:
              getdata?.Items[0].solar?.solrPG ??
              this.state.vehicalStateData.solar_solrPG,
            MechanicalAC:
              getdata?.Items[0].climateControl?.MechanicalAC ??
              this.state.vehicalStateData.MechanicalAC,
            ExtendedOperation:
              getdata?.Items[0].climateControl?.ExtendedOperation ??
              this.state.vehicalStateData.ExtendedOperation,
            UnlockImmobilizer:
              getdata?.Items[0].climateControl?.UnlockImmobilizer ??
              this.state.vehicalStateData.UnlockImmobilizer,
            selectedResultCodeOption:
              getdata?.Items[0].selectedResultCodeOption ??
              this.state.selectedResultCodeOption,
          },
        });

        this.setState({
          destinationselectedData:
            getdata?.Items[0].destination ?? this.state.destinationselectedData,
        });
        this.setState({ vehicleUploadData: getdata });
      })
      .catch((error) => {
        const err = error as AxiosError;
        if (err.response && err.response.status === 403) {
          messageService.sendStatus("403");
        }
      });
  }

  reversefunction(getdata: any) {
    console.log("inside reverse function!!");
    this.setState({
      vehicalStateData: {
        door_FDL: getdata.door.FDL,
        door_FDR: getdata.door.FDR,
        door_RDL: getdata.door.RDL,
        door_RDR: getdata.door.RDR,
        oC_door_FDL: getdata.door.oCFDL,
        oC_door_FDR: getdata.door.oCFDR,
        oC_door_RDL: getdata.door.oCRDL,
        oC_door_RDR: getdata.door.oCRDR,
        engine_sts: getdata.engine.sts,
        keydetected: getdata.precondition.keydetected,
        klegconfirmation: getdata.precondition.klegconfirmation,
        tcll: getdata.targetchargelid.tcll,
        svt: getdata.svtrequest.svt,
        cabin_outSts: getdata.cabin.outSts,
        seat_RStRem: getdata.seatRemainder.RS,
        health_fuel_Sts: getdata.health.fuel.Sts,
        health_fuel_Lvl_chrg: getdata.health.fuel.Lvl.chrg,
        health_fuel_Lvl_gas: getdata.health.fuel.Lvl.gas,
        health_fuel_Lvl_h2: getdata.health.fuel.Lvl.h2,
        health_DTE_tot: getdata.health.DTE.tot,
        health_DTE_ev: getdata.health.DTE.ev,
        health_DTE_gas: getdata.health.DTE.gas,
        health_DTE_h2: getdata.health.DTE.h2,
        health_DTE_GTDU: getdata.health.DTE.GTDU,
        health_DTE_evTDstSR: getdata.health.DTE.evTDstSR,
        health_DTE_PS_GPSPT: getdata.health.DTE.PS.GPSPT,
        health_DTE_PS_slr: getdata.health.DTE.PS.slr,
        health_DTE_PS_BPSPT: getdata.health.DTE.PS.BPSPT,
        health_odo_lfTm: getdata.health.odo.lfTm,
        health_odo_tripA: getdata.health.odo.tripA,
        health_odo_tripB: getdata.health.odo.tripB,
        health_fuelEco_lstTrip: getdata.health.fuelEco.lstTrip,
        health_fuelEco_lfTm: getdata.health.fuelEco.lfTm,
        health_TP_RLTP: getdata.health.TP.RLTP,
        health_TP_RRTP: getdata.health.TP.RRTP,
        health_TP_STP: getdata.health.TP.STP,
        health_TP_FLTP: getdata.health.TP.FLTP,
        health_TP_FRTP: getdata.health.TP.FRTP,
        health_battery_sts: getdata.health.battery.sts,
        health_battery_Keyfob: getdata.health.battery.Keyfob,
        health_oil_lfTm: getdata.health.oil.lfTm,
        extendedOpenings_trunk: getdata.extendedOpenings.trunk.lgC,
        extendedOpenings_trunks: getdata.extendedOpenings.trunk.BD,
        extendedOpenings_trunkl: getdata.extendedOpenings.trunk.trunkl,
        extendedOpenings_hatch: getdata.extendedOpenings.hatch.hatchl,
        extendedOpenings_hatchs: getdata.extendedOpenings.hatch.hatcho,
        extendedOpenings_tailgate: getdata.extendedOpenings.tailgate.tailgatel,
        extendedOpenings_tailgates: getdata.extendedOpenings.tailgate.tailgateo,
        extendedOpenings_hood: getdata.extendedOpenings.hood.hooddcs,
        extendedOpenings_roof: getdata.extendedOpenings.roof.slRfPos,
        extendedOpenings_roofs: getdata.extendedOpenings.roof.STR,
        windows_FWR: getdata.windows.FWR,
        windows_FWL: getdata.windows.FWL,
        windows_RWL: getdata.windows.RWL,
        windows_RWR: getdata.windows.RWR,
        windows_backdoor: getdata.windows.backdoor,
        // "windows_snRf": getdata.windows.snRf,
        alerts_Horn: getdata.alerts.Horn,
        alerts_Buzzer: getdata.alerts.Buzzer,
        alerts_Hazards: getdata.alerts.Hazards,
        lamps_FL: getdata.lamps.FL,
        lamps_RL: getdata.lamps.RL,
        lamps_Hazards: getdata.lamps.Hazards,
        seat_R2R: getdata.seat.R2R,
        seat_R2L: getdata.seat.R2L,
        seat_R3R: getdata.seat.R3R,
        seat_R3C: getdata.seat.R3C,
        seat_R3L: getdata.seat.R3L,
        plug_plgHsty: getdata.plug.plgHsty,
        plug_plgSts: getdata.plug.plgSts,
        charge_prof_pId: getdata.charge.prof.pId,
        charge_prof_chrgTyp: getdata.charge.prof.chrgTyp,
        charge_prof_SoT: getdata.charge.prof.SoT,
        charge_prof_SrT: getdata.charge.prof.SrT,
        charge_prof_active: getdata.charge.prof.active,
        charge_sdl_chrgET: getdata.charge.sdl.chrgET,
        charge_sdl_chrgST: getdata.charge.sdl.chrgST,
        charge_sdl_setTyp: getdata.charge.sdl.setTyp,
        charge_sdl_chrgWk: getdata.charge.sdl.chrgWk,
        charge_sdl_setID: getdata.charge.sdl.setID,
        charge_sdl_active: getdata.charge.sdl.active,
        charge_chrglmt: getdata.charge.chrglmt,
        charge_chrgPwrSW: getdata.charge.chrgPwrSW,
        charge_status_chrgPDF: getdata.charge.status.chrgPDF,
        charge_status_chrgRemAmt: getdata.charge.status.chrgRemAmt,
        charge_status_cntSts: getdata.charge.status.cntSts,
        charge_status_remChgTm: getdata.charge.status.remChgTm,
        charge_status_setChAcc: getdata.charge.status.setChAcc,
        charge_status_cntLkSts: getdata.charge.status.cntLkSts,
        charge_status_prtLidSts: getdata.charge.status.prtLidSts,
        charge_status_swtSts: getdata.charge.status.swtSts,
        charge_state_prtLidSts: getdata.charge.state.prtLidSts,
        solar_solrPG: getdata.solar.solrPG,
        MechanicalAC: getdata.climateControl.MechanicalAC,
        ExtendedOperation: getdata.climateControl.ExtendedOperation,
        UnlockImmobilizer: getdata.climateControl.UnlockImmobilizer,
        selectedResultCodeOption: getdata.selectedResultCodeOption,
      },
    });
    this.setState({
      modal: !this.state.modal,
    });
  }

  componentDidMount() {
    const queryParams = new URLSearchParams(window.location.search);
    const deviceid = queryParams.get("deviceid");
    console.info(deviceid);
    this.setState({ deviceID: deviceid });
    console.log("New Device ID", this.state.deviceID);
    axios
      .get(config.rootUrl + `/v1/configuration/device/rules/${deviceid}`, {
        headers: {
          "x-api-key": config.apiKey,
          Authorization: "Bearer " + this.props.jwtToken,
        },
      })
      .then((res) => {
        const getdata = res?.data?.items;
        const getdatall = res?.data;
        this.setState({ ruleAllData: getdatall });
        this.setState({ ruleData: getdata ? getdata : [] });
        console.log("Rule All Data", getdatall);
        console.log("Rule Get API Data", getdata);
      })
      .catch((error) => {
        const err = error as AxiosError;
        if (err.response && err.response.status === 403) {
          messageService.sendStatus("403");
        }
      });
  }
  // componentWillUnmount() {
  //   this.statusSubscription.unsubscribe();
  // }

  saveRuleClick() {
    console.log("check all data", this.state.ruleData);
    let ruleDataafterChange = this.state.ruleData.map((data: any) => {
      return { name: data.rule.ruleName, isActive: data.isActive };
    });
    // ruleDataafterChange.items = this.state.ruleData;
    console.log("check", ruleDataafterChange);

    axios
      .put(
        config.rootUrl +
        `/v1/configuration/device/rules/${this.state.deviceID}`,
        ruleDataafterChange,
        {
          headers: {
            "x-api-key": config.apiKey,
            Authorization: "Bearer " + this.props.jwtToken,
          },
        },
      )
      .then((res) => {
        console.log(res);
        toast.success("Rule Updated Successfully..!");
      })
      .catch((error) => {
        const err = error as AxiosError;
        if (err.response && err.response.status === 403) {
          messageService.sendStatus("403");
        }
      });
  }

  weeksOnclick = (event: any) => {
    let weekSelectedID = Number(event.currentTarget.value);

    if (event.currentTarget.checked) {
      this.setState({
        vehicalStateData: {
          ...this.state.vehicalStateData,
          charge_sdl_chrgWk: [
            ...this.state.vehicalStateData.charge_sdl_chrgWk,
            weekSelectedID,
          ],
        },
      });
    } else {
      this.setState({
        vehicalStateData: {
          ...this.state.vehicalStateData,
          charge_sdl_chrgWk:
            this.state.vehicalStateData.charge_sdl_chrgWk.filter(
              (seletedData: any) => seletedData !== weekSelectedID,
            ),
        },
      });
    }
  };

  handleClick1(id: any) {
    console.log(id, this.state);
    let newcheckData = this.state.vehicalStateData;
    newcheckData[id] = !newcheckData[id];
    this.setState({ vehicalStateData: newcheckData });
    console.log(newcheckData, "New Checking checkbox");
    console.log(this.state.vehicalStateData, "New Checking checkbox");
  }

  clearClick(e: any) {
    const queryParams1 = new URLSearchParams(window.location.search);
    const deviceid1 = queryParams1.get("deviceid");
    axios
      .get(config.rootUrl + `/v1/configuration/vehiclestatus/${deviceid1}`, {
        headers: {
          "x-api-key": config.apiKey,
          Authorization: "Bearer " + this.props.jwtToken,
        },
      })
      .then((res) => {
        const getdata = res.data;
        this.setState({
          vehicalStateData: {
            door_FDL:
              getdata?.door?.FDL ?? this.state.vehicalStateData.door_FDL,
            door_FDR:
              getdata?.door?.FDR ?? this.state.vehicalStateData.door_FDR,
            door_RDL:
              getdata?.door?.RDL ?? this.state.vehicalStateData.door_RDL,
            door_RDR:
              getdata?.door?.RDR ?? this.state.vehicalStateData.door_RDR,
            oC_door_FDL:
              getdata?.door?.oCFDL ?? this.state.vehicalStateData.oC_door_FDL,
            oC_door_FDR:
              getdata?.door?.oCFDR ?? this.state.vehicalStateData.oC_door_FDR,
            oC_door_RDL:
              getdata?.door?.oCRDL ?? this.state.vehicalStateData.oC_door_RDL,
            oC_door_RDR:
              getdata?.door?.oCRDR ?? this.state.vehicalStateData.oC_door_RDR,
            engine_sts:
              getdata?.engine?.sts ?? this.state.vehicalStateData.engine_sts,
            keydetected:
              getdata?.precondition?.keydetected ??
              this.state.vehicalStateData.keydetected,
            klegconfirmation:
              getdata?.precondition?.klegconfirmation ??
              this.state.vehicalStateData.klegconfirmation,
            tcll:
              getdata?.targetchargelid?.tcll ??
              this.state.vehicalStateData.tcll,
            svt: getdata?.svtrequest?.svt ?? this.state.vehicalStateData.svt,

            cabin_outSts:
              getdata?.cabin?.outSts ??
              this.state.vehicalStateData.cabin_outSts,
            seat_RStRem:
              getdata?.seatRemainder?.RS ??
              this.state.vehicalStateData.seat_RStRem,
            health_fuel_Sts:
              getdata?.health?.fuel?.Sts ??
              this.state.vehicalStateData.health_fuel_Sts,
            health_fuel_Lvl_chrg:
              getdata?.health?.fuel?.Lvl?.chrg ??
              this.state.vehicalStateData.health_fuel_Lvl_chrg,
            health_fuel_Lvl_gas:
              getdata?.health?.fuel?.Lvl?.gas ??
              this.state.vehicalStateData.health_fuel_Lvl_gas,
            health_fuel_Lvl_h2:
              getdata?.health?.fuel?.Lvl?.h2 ??
              this.state.vehicalStateData.health_fuel_Lvl_h2,
            health_DTE_tot:
              getdata?.health?.DTE?.tot ??
              this.state.vehicalStateData.health_DTE_tot,
            health_DTE_ev:
              getdata?.health?.DTE?.ev ??
              this.state.vehicalStateData.health_DTE_ev,
            health_DTE_gas:
              getdata?.health?.DTE?.gas ??
              this.state.vehicalStateData.health_DTE_gas,
            health_DTE_h2:
              getdata?.health?.DTE?.h2 ??
              this.state.vehicalStateData.health_DTE_h2,
            health_DTE_GTDU:
              getdata?.health?.DTE?.GTDU ??
              this.state.vehicalStateData.health_DTE_GTDU,
            health_DTE_evTDstSR:
              getdata?.health?.DTE?.evTDstSR ??
              this.state.vehicalStateData.health_DTE_evTDstSR,
            health_DTE_PS_GPSPT:
              getdata?.health?.DTE?.PS?.GPSPT ??
              this.state.vehicalStateData.health_DTE_PS_GPSPT,
            health_DTE_PS_slr:
              getdata?.health?.DTE?.PS?.slr ??
              this.state.vehicalStateData.health_DTE_PS_slr,
            health_DTE_PS_BPSPT:
              getdata?.health?.DTE?.PS?.BPSPT ??
              this.state.vehicalStateData.health_DTE_PS_BPSPT,
            health_odo_lfTm:
              getdata?.health?.odo?.lfTm ??
              this.state.vehicalStateData.health_odo_lfTm,
            health_odo_tripA:
              getdata?.health?.odo?.tripA ??
              this.state.vehicalStateData.health_odo_tripA,
            health_odo_tripB:
              getdata?.health?.odo?.tripB ??
              this.state.vehicalStateData.health_odo_tripB,
            health_fuelEco_lstTrip:
              getdata?.health?.fuelEco?.lstTrip ??
              this.state.vehicalStateData.health_fuelEco_lstTrip,
            health_fuelEco_lfTm:
              getdata?.health?.fuelEco?.lfTm ??
              this.state.vehicalStateData.health_fuelEco_lfTm,
            health_TP_RLTP:
              getdata?.health?.TP?.RLTP ??
              this.state.vehicalStateData.health_TP_RLTP,
            health_TP_RRTP:
              getdata?.health?.TP?.RRTP ??
              this.state.vehicalStateData.health_TP_RRTP,
            health_TP_STP:
              getdata?.health?.TP?.STP ??
              this.state.vehicalStateData.health_TP_STP,
            health_TP_FLTP:
              getdata?.health?.TP?.FLTP ??
              this.state.vehicalStateData.health_TP_FLTP,
            health_TP_FRTP:
              getdata?.health?.TP?.FRTP ??
              this.state.vehicalStateData.health_TP_FRTP,
            health_battery_sts:
              getdata?.health?.battery?.sts ??
              this.state.vehicalStateData.health_battery_sts,
            health_battery_Keyfob:
              getdata?.health?.battery?.Keyfob ??
              this.state.vehicalStateData.health_battery_Keyfob,
            health_oil_lfTm:
              getdata?.health?.oil?.lfTm ??
              this.state.vehicalStateData.health_oil_lfTm,
            extendedOpenings_trunk:
              getdata?.extendedOpenings?.trunk?.lgC ??
              this.state.vehicalStateData.extendedOpenings_trunk,
            extendedOpenings_trunks:
              getdata?.extendedOpenings?.trunk?.BD ??
              this.state.vehicalStateData.extendedOpenings_trunks,
            extendedOpenings_trunkl:
              getdata?.extendedOpenings?.trunk?.trunkl ??
              this.state.vehicalStateData.extendedOpenings_trunkl,
            extendedOpenings_hatch:
              getdata?.extendedOpenings?.hatch?.hatchl ??
              this.state.vehicalStateData.extendedOpenings_hatch,
            extendedOpenings_hatchs:
              getdata?.extendedOpenings?.hatch?.hatcho ??
              this.state.vehicalStateData.extendedOpenings_hatchs,
            extendedOpenings_tailgate:
              getdata?.extendedOpenings?.tailgate?.tailgatel ??
              this.state.vehicalStateData.extendedOpenings_tailgate,
            extendedOpenings_tailgates:
              getdata?.extendedOpenings?.tailgate?.tailgateo ??
              this.state.vehicalStateData.extendedOpenings_tailgates,
            extendedOpenings_hood:
              getdata?.extendedOpenings?.hood?.hooddcs ??
              this.state.vehicalStateData.extendedOpenings_hood,

            extendedOpenings_roof:
              getdata?.extendedOpenings?.roof?.slRfPos ??
              this.state.vehicalStateData.extendedOpenings_roof,
            extendedOpenings_roofs:
              getdata?.extendedOpenings?.roof?.STR ??
              this.state.vehicalStateData.extendedOpenings_roofs,
            windows_FWR:
              getdata?.windows?.FWR ?? this.state.vehicalStateData.windows_FWR,
            windows_FWL:
              getdata?.windows?.FWL ?? this.state.vehicalStateData.windows_FWL,
            windows_RWL:
              getdata?.windows?.RWL ?? this.state.vehicalStateData.windows_RWL,
            windows_RWR:
              getdata?.windows?.RWR ?? this.state.vehicalStateData.windows_RWR,
            windows_backdoor:
              getdata?.windows?.backdoor ??
              this.state.vehicalStateData.windows_backdoor,

            // "windows_snRf": getdata?.windows.snRf,
            alerts_Horn:
              getdata?.alerts?.Horn ?? this.state.vehicalStateData.alerts_Horn,
            alerts_Buzzer:
              getdata?.alerts?.Buzzer ??
              this.state.vehicalStateData.alerts_Buzzer,
            alerts_Hazards:
              getdata?.alerts?.Hazards ??
              this.state.vehicalStateData.alerts_Hazards,
            lamps_FL:
              getdata?.lamps?.FL ?? this.state.vehicalStateData.lamps_FL,
            lamps_RL:
              getdata?.lamps?.RL ?? this.state.vehicalStateData.lamps_RL,
            lamps_Hazards:
              getdata?.lamps?.Hazards ??
              this.state.vehicalStateData.lamps_Hazards,
            seat_R2R:
              getdata?.seat?.R2R ?? this.state.vehicalStateData.seat_R2R,
            seat_R2L:
              getdata?.seat?.R2L ?? this.state.vehicalStateData.seat_R2L,
            seat_R3R:
              getdata?.seat?.R3R ?? this.state.vehicalStateData.seat_R3R,
            seat_R3C:
              getdata?.seat?.R3C ?? this.state.vehicalStateData.seat_R3C,
            seat_R3L:
              getdata?.seat?.R3L ?? this.state.vehicalStateData.seat_R3L,

            plug_plgHsty:
              getdata?.plug?.plgHsty ??
              this.state.vehicalStateData.plug_plgHsty,
            plug_plgSts:
              getdata?.plug?.plgSts ?? this.state.vehicalStateData.plug_plgSts,
            charge_prof_pId:
              getdata?.charge?.prof?.pId ??
              this.state.vehicalStateData.charge_prof_pId,
            charge_prof_chrgTyp:
              getdata?.charge?.prof?.chrgTyp ??
              this.state.vehicalStateData.charge_prof_chrgTyp,
            charge_prof_SoT:
              getdata?.charge?.prof?.SoT ??
              this.state.vehicalStateData.charge_prof_SoT,
            charge_prof_SrT:
              getdata?.charge?.prof?.SrT ??
              this.state.vehicalStateData.charge_prof_SrT,
            charge_prof_active:
              getdata?.charge?.prof?.active ??
              this.state.vehicalStateData.charge_prof_active,
            charge_sdl_chrgET:
              getdata?.charge?.sdl?.chrgET ??
              this.state.vehicalStateData.charge_sdl_chrgET,
            charge_sdl_chrgST:
              getdata?.charge?.sdl?.chrgST ??
              this.state.vehicalStateData.charge_sdl_chrgST,
            charge_sdl_setTyp:
              getdata?.charge?.sdl?.setTyp ??
              this.state.vehicalStateData.charge_sdl_setTyp,
            charge_sdl_chrgWk:
              getdata?.charge?.sdl?.chrgWk ??
              this.state.vehicalStateData.charge_sdl_chrgWk,
            charge_sdl_setID:
              getdata?.charge?.sdl?.setID ??
              this.state.vehicalStateData.charge_sdl_setID,
            charge_sdl_active:
              getdata?.charge?.sdl?.active ??
              this.state.vehicalStateData.charge_sdl_active,
            charge_chrglmt:
              getdata?.charge?.chrglmt ??
              this.state.vehicalStateData.charge_chrglmt,
            charge_chrgPwrSW:
              getdata?.charge?.chrgPwrSW ??
              this.state.vehicalStateData.charge_chrgPwrSW,
            charge_status_chrgPDF:
              getdata?.charge?.status?.chrgPDF ??
              this.state.vehicalStateData.charge_status_chrgPDF,
            charge_status_chrgRemAmt:
              getdata?.charge?.status?.chrgRemAmt ??
              this.state.vehicalStateData.charge_status_chrgRemAmt,
            charge_status_cntSts:
              getdata?.charge?.status?.cntSts ??
              this.state.vehicalStateData.charge_status_cntSts,
            charge_status_remChgTm:
              getdata?.charge?.status?.remChgTm ??
              this.state.vehicalStateData.charge_status_remChgTm,
            charge_status_setChAcc:
              getdata?.charge?.status?.setChAcc ??
              this.state.vehicalStateData.charge_status_setChAcc,
            charge_status_cntLkSts:
              getdata?.charge?.status?.cntLkSts ??
              this.state.vehicalStateData.charge_status_cntLkSts,
            charge_status_prtLidSts:
              getdata?.charge?.status?.prtLidSts ??
              this.state.vehicalStateData.charge_status_prtLidSts,
            charge_status_swtSts:
              getdata?.charge?.status?.swtSts ??
              this.state.vehicalStateData.charge_status_swtSts,
            charge_state_prtLidSts:
              getdata?.charge?.state?.prtLidSts ??
              this.state.vehicalStateData.charge_state_prtLidSts,
            solar_solrPG:
              getdata?.solar?.solrPG ??
              this.state.vehicalStateData.solar_solrPG,
            MechanicalAC:
              getdata?.climateControl?.MechanicalAC ??
              this.state.vehicalStateData.MechanicalAC,
            ExtendedOperation:
              getdata?.climateControl?.ExtendedOperation ??
              this.state.vehicalStateData.ExtendedOperation,
            UnlockImmobilizer:
              getdata?.climateControl?.UnlockImmobilizer ??
              this.state.vehicalStateData.UnlockImmobilizer,
            selectedResultCodeOption:
              getdata?.selectedResultCodeOption ??
              this.state.selectedResultCodeOption,
          },
        });
        this.setState({
          destinationselectedData:
            getdata?.destination ?? this.state.destinationselectedData,
        });
        this.setState({ vehicleUploadData: getdata });
      })
      .catch((error) => {
        const err = error as AxiosError;
        if (err.response && err.response.status === 403) {
          messageService.sendStatus("403");
        }
      });
  }

  changeHandler = (value: any, element: any) => {
    console.info(value);
    let tempUpdate = this.state.vehicalStateData;
    tempUpdate[element] = value;
    console.log(tempUpdate, "djhsbdbsnjdbnsdj");
    this.setState({ vehicalStateData: tempUpdate });
  };

  volumehandleChange = (selectedOptions: any) => {
    this.setState({ selectedOption: selectedOptions });
    console.log("After Select" + JSON.stringify(selectedOptions.value));
    var strigydata = JSON.stringify(selectedOptions.value);
    this.setState({ selectfinaldata: selectedOptions.label });
  };

  destinametionvolumehandleChange = (selectedOptions: any) => {
    this.setState({ destinationselectedOption: selectedOptions });
    console.log("After Select" + JSON.stringify(selectedOptions.value));
    // var strigydata = JSON.stringify(selectedOptions.value);
    this.setState({ destinationselectedData: selectedOptions.label });
    console.log("destination data" + JSON.stringify(selectedOptions.label));
    if (selectedOptions.value == "mqttbroker") {
      this.setState({ mqttbrokertopicboolean: true });
    } else {
      this.setState({ mqttbrokertopicboolean: false });
      this.setState({ mqttopicselectedData: "" });
    }
  };

  mqttopichandleChange = (selectedOptions: any) => {
    this.setState({ mqttopicvalue: selectedOptions });
    this.setState({ mqttopicselectedData: selectedOptions.value });
    console.log("Topic data" + this.state.mqttopicselectedData);
  };

  seatR2Rchanges = (seatchangesval: any) => {
    let tempUpdate = this.state.vehicalStateData;
    tempUpdate["seat_R2R"] = seatchangesval.target.value;
    this.setState({ vehicalStateData: tempUpdate });
  };
  seatR2Lchanges = (seatchangesval: any) => {
    let tempUpdate = this.state.vehicalStateData;
    tempUpdate["seat_R2L"] = seatchangesval.target.value;
    this.setState({ vehicalStateData: tempUpdate });
  };
  seatR3Rchanges = (seatchangesval: any) => {
    let tempUpdate = this.state.vehicalStateData;
    tempUpdate["seat_R3R"] = seatchangesval.target.value;
    this.setState({ vehicalStateData: tempUpdate });
  };
  seatR3Cchanges = (seatchangesval: any) => {
    let tempUpdate = this.state.vehicalStateData;
    tempUpdate["seat_R3C"] = seatchangesval.target.value;
    this.setState({ vehicalStateData: tempUpdate });
  };
  seatR3Lchanges = (seatchangesval: any) => {
    let tempUpdate = this.state.vehicalStateData;
    tempUpdate["seat_R3L"] = seatchangesval.target.value;
    this.setState({ vehicalStateData: tempUpdate });
  };

  chargedropdown = (data: any) => {
    console.log("data check", data.target.value, data.target.name);
    let routeState = this.state.vehicalStateData;
    routeState[data.target.name] = data.target.value;
    this.setState({ vehicalStateData: routeState });
    console.log("dropdown value check", this.state.vehicalStateData);
  };

  onSubmit(e: any) {
    e.preventDefault();
    console.log(this.state);
    let VehicleUpdatedData: any = {};
    let VehicleFormateData = this.formDataToJSON();
    console.log("Final Data", VehicleFormateData);
    //this.setState({resultcodedb: VehicleFormateData.selectedResultCodeOption})
    this.setState((prevState: any) => {
      const currentResultCode = VehicleFormateData.selectedResultCodeOption;
      const previousResultCode = prevState.resultcodedb;
      const newResultCode =
        currentResultCode !== undefined &&
          currentResultCode !== null &&
          currentResultCode !== previousResultCode
          ? currentResultCode
          : previousResultCode;
      return {
        resultcodedb: newResultCode,
        dropdownKey: prevState.dropdownKey + 1,
      };
    });
    axios
      .post(
        config.rootUrl + "/v1/configuration/vehiclestatus/create",
        VehicleFormateData,
        {
          headers: {
            "x-api-key": config.apiKey,
            Authorization: "Bearer " + this.props.jwtToken,
          },
        },
      )
      .then((res) => {
        console.log(res);
        toast.success("Vehicle Data Uploaded Successfully..!");
      })
      .catch((error) => {
        const err = error as AxiosError;
        if (err.response && err.response.status === 403) {
          messageService.sendStatus("403");
        }
      });
  }

  formDataToJSON() {
    console.log("Checking", this.state);
    return {
      vin: this.state.deviceID,
      destination: this.state.destinationselectedData,
      mqttTopic: this.state.mqttopicselectedData,
      door: {
        FDL: this.state.vehicalStateData.door_FDL,
        FDR: this.state.vehicalStateData.door_FDR,
        RDL: this.state.vehicalStateData.door_RDL,
        RDR: this.state.vehicalStateData.door_RDR,
        oCFDL: this.state.vehicalStateData.oC_door_FDL,
        oCFDR: this.state.vehicalStateData.oC_door_FDR,
        oCRDL: this.state.vehicalStateData.oC_door_RDL,
        oCRDR: this.state.vehicalStateData.oC_door_RDR,
      },
      engine: {
        sts: this.state.vehicalStateData.engine_sts,
      },
      svtrequest: {
        svt: this.state.vehicalStateData.svt,
      },
      targetchargelid: {
        tcll: this.state.vehicalStateData.tcll,
      },
      precondition: {
        keydetected: this.state.vehicalStateData.keydetected,
        klegconfirmation: this.state.vehicalStateData.klegconfirmation,
      },
      cabin: {
        outSts: this.state.vehicalStateData.cabin_outSts,
      },
      seatRemainder: {
        RS: this.state.vehicalStateData.seat_RStRem,
      },
      health: {
        fuel: {
          Sts: this.state.vehicalStateData.health_fuel_Sts,
          Lvl: {
            chrg: this.state.vehicalStateData.health_fuel_Lvl_chrg,
            gas: this.state.vehicalStateData.health_fuel_Lvl_gas,
            h2: this.state.vehicalStateData.health_fuel_Lvl_h2,
          },
        },
        DTE: {
          tot: this.state.vehicalStateData.health_DTE_tot,
          ev: this.state.vehicalStateData.health_DTE_ev,
          gas: this.state.vehicalStateData.health_DTE_gas,
          h2: this.state.vehicalStateData.health_DTE_h2,
          GTDU: this.state.vehicalStateData.health_DTE_GTDU,
          evTDstSR: this.state.vehicalStateData.health_DTE_evTDstSR,
          PS: {
            GPSPT: this.state.vehicalStateData.health_DTE_PS_GPSPT,
            slr: this.state.vehicalStateData.health_DTE_PS_slr,
            BPSPT: this.state.vehicalStateData.health_DTE_PS_BPSPT,
          },
        },
        odo: {
          lfTm: this.state.vehicalStateData.health_odo_lfTm,
          tripA: this.state.vehicalStateData.health_odo_tripA,
          tripB: this.state.vehicalStateData.health_odo_tripB,
        },
        fuelEco: {
          lstTrip: this.state.vehicalStateData.health_fuelEco_lstTrip,
          lfTm: this.state.vehicalStateData.health_fuelEco_lfTm,
        },
        TP: {
          RLTP: this.state.vehicalStateData.health_TP_RLTP,
          RRTP: this.state.vehicalStateData.health_TP_RRTP,
          STP: this.state.vehicalStateData.health_TP_STP,
          FLTP: this.state.vehicalStateData.health_TP_FLTP,
          FRTP: this.state.vehicalStateData.health_TP_FRTP,
        },
        battery: {
          sts: this.state.vehicalStateData.health_battery_sts,
          Keyfob: this.state.vehicalStateData.health_battery_Keyfob,
        },
        oil: {
          lfTm: this.state.vehicalStateData.health_oil_lfTm,
        },
      },
      extendedOpenings: {
        roof: {
          slRfPos: this.state.vehicalStateData.extendedOpenings_roof,
          STR: this.state.vehicalStateData.extendedOpenings_roofs,
        },
        trunk: {
          lgC: this.state.vehicalStateData.extendedOpenings_trunk,
          BD: this.state.vehicalStateData.extendedOpenings_trunk,
          trunkl: this.state.vehicalStateData.extendedOpenings_trunkl,
        },
        hatch: {
          hatchl: this.state.vehicalStateData.extendedOpenings_hatch,
          hatcho: this.state.vehicalStateData.extendedOpenings_hatchs,
        },
        tailgate: {
          tailgatel: this.state.vehicalStateData.extendedOpenings_tailgate,
          tailgateo: this.state.vehicalStateData.extendedOpenings_tailgates,
        },
        hood: {
          hooddcs: this.state.vehicalStateData.extendedOpenings_hood,
        },
      },
      windows: {
        FWR: this.state.vehicalStateData.windows_FWR,
        FWL: this.state.vehicalStateData.windows_FWL,
        RWL: this.state.vehicalStateData.windows_RWL,
        RWR: this.state.vehicalStateData.windows_RWR,
        backdoor: this.state.vehicalStateData.windows_backdoor,
        // "snRf": this.state.vehicalStateData.windows_snRf
      },
      alerts: {
        Horn: this.state.vehicalStateData.alerts_Horn,
        Buzzer: this.state.vehicalStateData.alerts_Buzzer,
        Hazards: this.state.vehicalStateData.alerts_Hazards,
      },
      lamps: {
        FL: this.state.vehicalStateData.lamps_FL,
        RL: this.state.vehicalStateData.lamps_RL,
        Hazards: this.state.vehicalStateData.lamps_Hazards,
      },
      seat: {
        R2R: this.state.vehicalStateData.seat_R2R,
        R2L: this.state.vehicalStateData.seat_R2L,
        R3R: this.state.vehicalStateData.seat_R3R,
        R3C: this.state.vehicalStateData.seat_R3C,
        R3L: this.state.vehicalStateData.seat_R3L,
      },
      plug: {
        plgHsty: this.state.vehicalStateData.plug_plgHsty,
        plgSts: this.state.vehicalStateData.plug_plgSts,
      },
      charge: {
        prof: {
          pId: this.state.vehicalStateData.charge_prof_pId,
          chrgTyp: this.state.vehicalStateData.charge_prof_chrgTyp,
          SoT: this.state.vehicalStateData.charge_prof_SoT,
          SrT: this.state.vehicalStateData.charge_prof_SrT,
          active: this.state.vehicalStateData.charge_prof_active,
        },
        sdl: {
          chrgET: this.state.vehicalStateData.charge_sdl_chrgET,
          chrgST: this.state.vehicalStateData.charge_sdl_chrgST,
          setTyp: this.state.vehicalStateData.charge_sdl_setTyp,
          chrgWk: this.state.vehicalStateData.charge_sdl_chrgWk,
          // "chrgWk": this.state.vehicalStateData.charge_sdl_setTyp,
          setID: this.state.vehicalStateData.charge_sdl_setID,
          active: this.state.vehicalStateData.charge_sdl_active,
        },
        chrglmt: this.state.vehicalStateData.charge_chrglmt,
        chrgPwrSW: this.state.vehicalStateData.charge_chrgPwrSW,
        status: {
          chrgPDF: this.state.vehicalStateData.charge_status_chrgPDF,
          chrgRemAmt: this.state.vehicalStateData.charge_status_chrgRemAmt,
          cntSts: this.state.vehicalStateData.charge_status_cntSts,
          remChgTm: this.state.vehicalStateData.charge_status_remChgTm,
          setChAcc: this.state.vehicalStateData.charge_status_setChAcc,
          cntLkSts: this.state.vehicalStateData.charge_status_cntLkSts,
          prtLidSts: this.state.vehicalStateData.charge_status_prtLidSts,
          swtSts: this.state.vehicalStateData.charge_status_swtSts,
        },
        state: {
          prtLidSts: this.state.vehicalStateData.charge_state_prtLidSts,
        },
      },
      solar: {
        solrPG: this.state.vehicalStateData.solar_solrPG,
      },
      climateControl: {
        MechanicalAC: this.state.vehicalStateData.MechanicalAC,
        ExtendedOperation: this.state.vehicalStateData.ExtendedOperation,
        UnlockImmobilizer: this.state.vehicalStateData.UnlockImmobilizer,
      },
      selectedResultCodeOption: this.state.selectedResultCodeOption,
      ts: Date.now(),
    };
  }

  toggle = () => {
    let formDataToJSONData = this.formDataToJSON();
    this.setState({ vehicleUploadData: formDataToJSONData });
    this.setState({
      modal: !this.state.modal,
    });
  };

  tabhandleSelect = (index: any) => {
    this.setState({ selectedIndex: index });
    sessionStorage.setItem("selectedTabIndex", index);
  };

  innertabhandleSelect = (index: any) => {
    this.setState({ innerselectedIndex: index });
  };

  rulehandleisactive = (index: any) => {
    let Tempdata = this.state.ruleData;
    Tempdata[index].isActive = !Tempdata[index].isActive;

    //console.log('Get Index', this.state.ruleData[index], index);

    this.setState({ ruleData: Tempdata });
  };

  getRulesArray = (innerRuleArray: any) => {
    return innerRuleArray.map((data: any) => (
      <div className="row pt-2 border-bottom">
        <div className="col-3">
          <div className="form-group">
            <label>Resource Key</label>
            <input
              type="text"
              id={data.resourceKey}
              className="form-control"
              name={data.resourceKey}
              value={data.resourceKey}
              disabled
            />
          </div>
        </div>
        <div className="col-3">
          <div className="form-group">
            <label>Resource Value</label>
            <input
              type="text"
              id={data.resourceValue}
              className="form-control"
              name={data.resourceValue}
              value={data.resourceValue}
              disabled
            />
          </div>
        </div>
        {data.condition && (
          <div className="col-3 adjestmargin">
            <div className="form-group">
              <label>Conditions</label>
              <input
                type="text"
                className="form-control"
                value={data.condition}
                disabled
              />
            </div>
          </div>
        )}
      </div>
    ));
  };

  handleResultCodeOptionChange = (selectedResultCodeOption: any) => {
    this.setState({ selectedResultCodeOption });
  };

  render() {
    const destinationOption: any = [
      { value: "dynamoDB", label: "DynamoDB" },
      { value: "mqttbroker", label: "MQTT broker" },
    ];

    const mqttopicvalueOption: any = [
      {
        value: "{vehicleId}/V2C/OEMSW/remoteservices/forgetinform/data-upload",
        label: "{vehicleId}/V2C/OEMSW/remoteservices/forgetinform/data-upload",
      },
      {
        value: "{vehicleId}/V2C/OEMSW/remoteservices/remotecheck/data-upload",
        label: "{vehicleId}/V2C/OEMSW/remoteservices/remotecheck/data-upload",
      },
    ];

    console.log("Rule after set", this.state.ruleData);

    return (
      <div>
        {/* {this.state.sessionExpired ? (
          <SessionExpired />
        ) : null} */}
        <div className="container-fluid">
          <Tabs
            selectedIndex={this.state.selectedIndex}
            onSelect={this.tabhandleSelect}
          >
            <TabList>
              <Tab>Vehicle Data</Tab>
              <Tab>Vehicle Function</Tab>
              {/* <Tab>Rules</Tab> */}
              <Tab>Kafka Simulator</Tab>
            </TabList>
            <TabPanel>
              <div className="row">
                <div className="col-2 justpositioncls d-none">
                  <Select
                    value={this.state.destinationselectedOption}
                    defaultValue={this.state.destinationselectedOption}
                    onChange={this.destinametionvolumehandleChange}
                    options={destinationOption}
                  />
                  {/* <span className="fs-5 py-3 fw-bold d-flex justify-content-between">Vehicle Data - Upload</span> */}
                </div>
                {this.state.mqttbrokertopicboolean ? (
                  <div className="col-3 d-none">
                    <Select
                      value={this.state.mqttopicvalue}
                      defaultValue={this.state.mqttopicvalue}
                      onChange={this.mqttopichandleChange}
                      options={mqttopicvalueOption}
                    />
                  </div>
                ) : (
                  ""
                )}

                <div className="col-3">
                  <span className="ml-0 fs-5 py-3 fw-bold d-flex justify-content-between">
                    VIN : {this.state.deviceID}
                  </span>
                </div>

                <div className="col-7 mt-1 ml-auto">
                  <MDBBtn
                    onClick={this.toggle}
                    color="primary"
                    className="btn btn-primary d-flex ms-auto mt-1 py-2"
                  >
                    JSON View
                  </MDBBtn>
                </div>
              </div>
              <div className="row">
                {/* <h4>
                  Existing Result Code Option:{" "}
                  {this.state.resultcodedb}
                </h4> */}
                <VehicleSimulator
                  vehicalStateData={this.state.vehicalStateData}
                  handleClick1={this.handleClick1.bind(this)}
                  onResultCodeOptionChange={this.handleResultCodeOptionChange}
                  resultcodedb={this.state.resultcodedb}
                  key={this.state.dropdownKey}
                />
                <VehicleFormView
                  selectedOption={this.state.selectedOption}
                  selectfinaldata={this.state.selectfinaldata}
                  vehicalStateData={this.state.vehicalStateData}
                  changeHandler={this.changeHandler.bind(this)}
                  volumehandleChange={this.volumehandleChange.bind(this)}
                  onSubmit={this.onSubmit.bind(this)}
                  handleClick1={this.handleClick1.bind(this)}
                  seatR2Rchanges={this.seatR2Rchanges.bind(this)}
                  seatR2Lchanges={this.seatR2Lchanges.bind(this)}
                  seatR3Rchanges={this.seatR3Rchanges.bind(this)}
                  seatR3Cchanges={this.seatR3Cchanges.bind(this)}
                  seatR3Lchanges={this.seatR3Lchanges.bind(this)}
                  clearClick={this.clearClick.bind(this)}
                  chargedropdown={this.chargedropdown.bind(this)}
                  weeks={this.state.weeks}
                  selectedweeks={this.state.selectedweeks}
                  weeksOnclick={this.weeksOnclick.bind(this)}
                />
              </div>
            </TabPanel>

            <TabPanel>
              <VehicleFunction jwtToken={this.props.jwtToken} />
            </TabPanel>
               <TabPanel>
              <KafkaSimulator jwtToken={this.props.jwtToken} />
            </TabPanel>

            <TabPanel>
              <Tabs
                selectedIndex={this.state.innerselectedIndex}
                onSelect={this.innertabhandleSelect}
              >
                <TabList>
                  {this.state.ruleData.map((data: any, index: any) => (
                    // <TabHeader label={data.feature} id={data.id} checkBoxFlag={data.isActive}/>
                    <Tab>
                      <span>{data.feature}</span>
                      <input
                        type="checkbox"
                        className="doorinput rule"
                        id={data.id}
                        checked={data.isActive}
                        onChange={() => {
                          this.rulehandleisactive(index);
                        }}
                      />
                      <label
                        htmlFor={data.id}
                        className="doorinputlabel rule mt-2"
                      >
                        <div className="knob"></div>
                      </label>
                    </Tab>
                  ))}
                </TabList>
                {this.state.ruleData.map((data: any) => (
                  <TabPanel>
                    <div className="row baseRuletop">
                      <div className="col-3">
                        <div className="form-group">
                          <label>Rule Id</label>
                          <input
                            type="text"
                            id={data?.rule?.ruleId}
                            className="form-control"
                            value={data?.rule?.ruleId}
                            disabled
                          />
                        </div>
                      </div>
                      <div className="col-3">
                        <div className="form-group">
                          <label>Rule Name</label>
                          <input
                            type="text"
                            id={data?.rule?.ruleName}
                            className="form-control"
                            value={data?.rule?.ruleName}
                            disabled
                          />
                        </div>
                      </div>
                      <div className="col-3">
                        <div className="form-group">
                          <label>Description</label>
                          <input
                            type="text"
                            id={data?.rule?.description}
                            className="form-control"
                            value={data?.rule?.description}
                            disabled
                          />
                        </div>
                      </div>
                      <div className="col-1">
                        <div className="form-group mt-4 pt-2">
                          <input
                            type="checkbox"
                            id={`ruleId${data?.rule?.ruleId}`}
                            name="mainruleisActive"
                            className="float-left mt-1"
                            checked={data?.rule?.isActive}
                          />
                          <label
                            className="ml-3"
                            htmlFor={`ruleId${data?.rule?.ruleId}`}
                          >
                            isActive
                          </label>
                        </div>
                      </div>
                    </div>
                    {this.getRulesArray(data?.rule?.rules ?? [])}
                    <div className="groupfooter mt-3">
                      <div className="row  baseRuletop">
                        <div className="col-3">
                          <div className="form-group">
                            <label>Error Messages</label>
                            <input
                              type="text"
                              id={data?.rule?.action?.errorMessage}
                              name={data?.rule?.action?.errorMessage}
                              className="form-control"
                              value={data?.rule?.action?.errorMessage}
                              disabled
                            />
                          </div>
                        </div>
                        <div className="col-3">
                          <div className="form-group">
                            <label>Error Code</label>
                            <input
                              type="text"
                              id={data?.rule?.action?.errorCode}
                              name={data?.rule?.action?.errorCode}
                              className="form-control"
                              value={data?.rule?.action?.errorCode}
                              disabled
                            />
                          </div>
                        </div>
                        <div className="col-3">
                          <div className="form-group">
                            <label>Delay</label>
                            <input
                              type="text"
                              id={data?.rule?.action?.delay}
                              name={data?.rule?.action?.delay}
                              className="form-control"
                              value={data?.rule?.action?.delay}
                              disabled
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </TabPanel>
                ))}

                <input
                  className="btn btn-primary float-right"
                  type="button"
                  value="Save"
                  onClick={() => this.saveRuleClick()}
                />
              </Tabs>
            </TabPanel>

         
          </Tabs>
        </div>

        <MDBModal
          backdrop={false}
          isOpen={this.state.modal}
          toggle={this.toggle}
          size="lg"
        >
          <MDBModalHeader className="font-weight-bold" toggle={this.toggle}>
            Vehicle Data Uploaded - JSON View
          </MDBModalHeader>
          <MDBModalBody>
            <Container fluid>
              <VehileJsonEdit
                reversefunction={this.reversefunction.bind(this)}
                src={this.state.vehicleUploadData}
                vehicleUploadData={this.state.vehicleUploadData}
                toggle={this.toggle}
              />
            </Container>
          </MDBModalBody>
        </MDBModal>
      </div>
    );
  }
}

export default DeviceTwin;
